import IAMTires from 'pages/CatalogPage/IAM/Tires/IAMTires';

export default IAMTires;
